import { render, staticRenderFns } from "./ClientDetailsTab.vue?vue&type=template&id=12ffd24a&"
import script from "./ClientDetailsTab.vue?vue&type=script&lang=ts&"
export * from "./ClientDetailsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports